import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

const CALLBACK_NAME = '__nyzedInitGoogleMaps';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loadPromise?: Promise<void>;

  get hasKey(): boolean {
    return !!environment.googleMapsApiKey;
  }

  load(): Promise<void> {
    if (this.loadPromise) return this.loadPromise;

    if (!this.hasKey) {
      return Promise.reject(new Error('Google Maps API key mancante'));
    }

    if ((window as any).google?.maps?.places) {
      this.loadPromise = Promise.resolve();
      return this.loadPromise;
    }

    this.loadPromise = new Promise<void>((resolve, reject) => {
      (window as any)[CALLBACK_NAME] = () => resolve();

      const params = new URLSearchParams({
        key: environment.googleMapsApiKey,
        libraries: 'places',
        loading: 'async',
        callback: CALLBACK_NAME,
      });

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
      script.async = true;
      script.onerror = () => reject(new Error('Caricamento Google Maps fallito'));
      document.head.appendChild(script);
    });

    return this.loadPromise;
  }
}
